// extracted by mini-css-extract-plugin
module.exports = {"newGameSettingsDialog":"styles_newGameSettingsDialog__115RL"};